import { onDestroy } from "svelte";

/**
 * Gives a component an AbortSignal tied to its lifetime. Requests started with
 * it are cancelled when the component is destroyed, so a slow view that the
 * user has already left stops writing into state that no longer exists.
 *
 * Call it once at the top level of a component:
 *
 *   const abortSignal = createRequestScope();
 *   fetchWithSession(url, { signal: abortSignal });
 *
 * fetchWrapper treats an aborted request as expected and shows no toast.
 */
export function createRequestScope() {
  const controller = new AbortController();
  onDestroy(() => controller.abort());
  return controller.signal;
}

/** True for the rejection a cancelled request produces. */
export function isAborted(error) {
  return error?.name === "AbortError";
}
